const READ_KEY = "als_parent_notification_reads";
const CLEARED_KEY = "als_parent_notification_cleared";
export const PARENT_NOTIFICATIONS_EVENT = "als-parent-notifications-updated";

function notifyParentNotificationsUpdated() {
  window.dispatchEvent(new CustomEvent(PARENT_NOTIFICATIONS_EVENT));
}

export function loadParentNotificationReads() {
  try {
    const raw = localStorage.getItem(READ_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveParentNotificationReads(ids) {
  const next = [...new Set(ids)].slice(0, 300);
  localStorage.setItem(READ_KEY, JSON.stringify(next));
  notifyParentNotificationsUpdated();
}

export function markParentNotificationsRead(ids) {
  const current = loadParentNotificationReads();
  saveParentNotificationReads([...ids, ...current]);
}

export function loadParentNotificationCleared() {
  try {
    const raw = localStorage.getItem(CLEARED_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function clearParentNotifications(ids) {
  const current = loadParentNotificationCleared();
  const next = [...new Set([...ids, ...current])].slice(0, 400);
  localStorage.setItem(CLEARED_KEY, JSON.stringify(next));
  markParentNotificationsRead(ids);
  notifyParentNotificationsUpdated();
}

export function filterVisibleParentNotifications(items = []) {
  const cleared = new Set(loadParentNotificationCleared());
  return items.filter((item) => item?.id && !cleared.has(item.id));
}

export function countUnreadParentNotifications(items = []) {
  const visible = filterVisibleParentNotifications(items);
  const reads = new Set(loadParentNotificationReads());
  return visible.filter((item) => item?.id && !reads.has(item.id)).length;
}
